import { useNavigate } from "@tanstack/react-router"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "design-system/atoms/Dialog"
import { useCreateMessengerIntegrationMutation } from "modules/settings/hooks/messenger/useCreateMessengerIntegrationMutation"
import { Loading } from "modules/shared/components/Loading"
import { useCallback, useEffect, useRef } from "react"
import { useTranslation } from "react-i18next"
import { Route as AddMessengerIntegrationRoute } from "routes/_base/_auth/settings/channels/messenger/new"

export const AddMessengerIntegration = () => {
  const hasAlreadyValidated = useRef(false)
  const { t } = useTranslation()
  const { code } = AddMessengerIntegrationRoute.useSearch()
  const navigate = useNavigate()
  const { mutateAsync } = useCreateMessengerIntegrationMutation()

  const onOpenChange = useCallback(
    (isOpen: boolean = false) => {
      if (!isOpen) {
        navigate({ to: "/settings/channels/messenger" })
      }
    },
    [navigate],
  )

  useEffect(() => {
    if (!hasAlreadyValidated.current) {
      hasAlreadyValidated.current = true
      mutateAsync({ code }).then(() => {
        onOpenChange(false)
      })
    }
  }, [mutateAsync, code, hasAlreadyValidated, onOpenChange])

  return (
    <Dialog open onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>{t("settings.integrations.messenger.addIntegration.title")}</DialogTitle>
          <DialogDescription>
            {t("settings.integrations.messenger.addIntegration.description")}
          </DialogDescription>
        </DialogHeader>
        <div className="mt-2">
          <Loading size={6} />
        </div>
      </DialogContent>
    </Dialog>
  )
}
